

import {Component, Prop, Vue} from "vue-property-decorator";
import {listMarkNumber, save} from "@/api/mark-management";
import {listCustomerBrand} from "@/api/brand";

@Component({name: "CreateOrEdit"})
export default class extends Vue {
  @Prop({ default: "" }) private markType: string;
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "" }) private title: string;
  @Prop({ default: "" }) private customerId: string;
  @Prop({ default: false }) private editBoolean: boolean;
  @Prop({default: {} }) private editData: MarkForm;
  private form: MarkForm = new MarkForm();
  private normalMarkOptions = [
    {label: '箱唛', value: 'CTN_MARK'},
    {label: '托唛', value: 'PLT_MARK'}
  ];
  private markNumber = [];
  private currentMarkNumber = "";
  private customerBrands = [];

  private mainMarkReplaceItem = "";
  private sideMarkReplaceItem = "";
  private mainMarkItem = [
    {label: "自编号", value: "$自编号$"},
    {label: "自编号+顺序号", value: "$自编号+顺序号$"},
    {label: "PO NO", value: "$PO NO$"},
    {label: "英文品名", value: "$英文品名$"},
    {label: "华强品名", value: "$华强品名$"},
    {label: "号码类型", value: "$号码类型$"},
    {label: "订单拆分号", value: "$订单拆分号$"},
  ];
  private sideMarkItem = [
    {label: "自编号", value: "$自编号$"},
    {label: "自编号+顺序号", value: "$自编号+顺序号$"},
    {label: "PO NO", value: "$PO NO$"},
    {label: "英文品名", value: "$英文品名$"},
    {label: "华强品名", value: "$华强品名$"},
    {label: "号码类型", value: "$号码类型$"},
    {label: "华强侧唛二维码内容", value: "$华强侧唛二维码内容$"},
    {label: "订单拆分号", value: "$订单拆分号$"},
  ];

  private mainMarkContent = "";
  private sideMarkContent = "";

  created() {
    this.getMarkNumber();
    this.getCustomerBrand();
  }

  private async getMarkNumber() {
    this.markNumber = await listMarkNumber() as any;
  }

  private async getCustomerBrand() {
    this.customerBrands = await listCustomerBrand(this.customerId) as any;
  }

  private open() {
    if (this.editBoolean) {
      this.form = { ...this.editData };
      this.currentMarkNumber = this.editData.markNumber;
      this.mainMarkContent = this.editData.mainMarkContent;
      this.sideMarkContent = this.editData.sideMarkContent;
    }
    this.form.customerId = this.customerId;
  }

  private close() {
    this.form = new MarkForm();
    this.mainMarkContent = "";
    this.sideMarkContent = "";
    this.$emit("closeDialog");
    this.$emit("update:show", false);
  }

  private cancel() {
    this.close();
  }

  private markNumberChange(val) {
    this.currentMarkNumber = this.markNumber.find(v => v.name === val).desc;
  }

  private brandChange(val) {
    this.form.brand = this.customerBrands.find(v => v.id === val).name;
  }

  private async submit() {
    if (this.markType === "otherMark") {
      this.form.markType = "OTHER_MARK";
    }
    if (this.markType === "customMark") {
      if (this.sideMarkContent.includes("$华强侧唛二维码内容$")) {
        if (this.currentMarkNumber === "" ||
            this.currentMarkNumber === null ||
            this.currentMarkNumber === undefined) {
          this.$message({
            message: "要添加'华强侧唛二维码内容'，请先选择号码类型",
            type: "warning"
          });
          return;
        }
      }
      const allowedValues1 = ["自编号", "自编号+顺序号", "PO NO", "英文品名", "华强品名", "号码类型", "订单拆分号"];
      const result1 = this.checkDollarContent("主唛", this.mainMarkContent, allowedValues1);
      if (!result1) {
        return;
      }
      const allowedValues2 = ["自编号", "自编号+顺序号", "PO NO", "英文品名", "华强品名", "号码类型", "华强侧唛二维码内容", "订单拆分号"];
      const  result2 = this.checkDollarContent("侧唛", this.sideMarkContent, allowedValues2);
      if (!result2) {
        return;
      }
    }
    this.form.custom = this.markType === "customMark";
    this.form.mainMarkContent = this.mainMarkContent === "" ? null : this.mainMarkContent;
    this.form.sideMarkContent = this.sideMarkContent === "" ? null : this.sideMarkContent;
    await save(this.form);
    this.close();
    this.$emit("updateList");
  }

  private checkDollarContent(mark: string, str: string, allowedValues: string[]) {
    // 1. 检查$符是否成对出现
    const dollarCount = (str.match(/\$/g) || []).length;
    if (dollarCount % 2 !== 0) {
      this.$message.error("请保证" + mark +"内容中的$号成对存在,两个$号中间的内容为系统带出替换的部分");
      return false;
    }
    // 2. 提取所有两个$号之间的内容
    const regex = /\$(.*?)\$/g;
    let match;
    const contents = [];

    while ((match = regex.exec(str)) !== null) {
      contents.push(match[1]);
    }

    // 3. 检查每个内容是否在允许列表中
    for (const content of contents) {
      if (!allowedValues.includes(content)) {
        this.$message.error(mark + "两个$号中间的内容错误，请确保内容的文字跟选项中的文字一致");
        return false;
      }
    }
    return true;
  }

  private addMainMarkText() {
    if (!this.mainMarkReplaceItem) {
      return;
    }
    const textarea = this.$refs.mainMarkTextarea as any;
    const text = this.mainMarkContent;
    const cursorPos = textarea.$refs.textarea.selectionStart;
    this.mainMarkContent =
        text.substring(0, cursorPos) +
        this.mainMarkReplaceItem +
        text.substring(cursorPos);
    const length = this.mainMarkReplaceItem.length;
    // 重置选择
    this.mainMarkReplaceItem = "";
    // 聚焦文本框并设置光标位置
    this.$nextTick(() => {
      const newCursorPos = cursorPos + length;
      textarea.focus();
      textarea.$refs.textarea.setSelectionRange(newCursorPos, newCursorPos);
    });
  }

  private addToSideMarkText() {
    if (!this.sideMarkReplaceItem) {
      return;
    }
    if (this.sideMarkReplaceItem === "$华强侧唛二维码内容$") {
      if (this.currentMarkNumber === "") {
        this.$message({
          message: "要添加'华强侧唛二维码内容'，请先选择号码类型",
          type: "warning"
        });
        return;
      }
    }
    const textarea = this.$refs.sideMarkTextarea as any;
    const text = this.sideMarkContent;
    const cursorPos = textarea.$refs.textarea.selectionStart;
    this.sideMarkContent =
        text.substring(0, cursorPos) +
        this.sideMarkReplaceItem +
        text.substring(cursorPos);
    const length = this.sideMarkReplaceItem.length;
    // 重置选择
    this.sideMarkReplaceItem = "";
    // 聚焦文本框并设置光标位置
    this.$nextTick(() => {
      const newCursorPos = cursorPos + length;
      textarea.focus();
      textarea.$refs.textarea.setSelectionRange(newCursorPos, newCursorPos);
    });
  }

}
export class MarkForm {
  id: string;
  customerId: string;
  markType: string;
  name: string;
  brand: string;
  brandId: string;
  mainMarkFormat: string;
  sideMarkFormat: string;
  markLetters: string;
  markNumber: string;
  otherMarkContent: string;
  mainMarkContent: string;
  sideMarkContent: string;
  custom: boolean;
}
